import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/shop/single-product-1.webp'
import _imports_1 from '../../assets/img/icons/star-fill.svg'
import _imports_2 from '../../assets/img/icons/star-line.svg'
import _imports_3 from '../../assets/img/blog/avatar-1.webp'
import _imports_4 from '../../assets/img/blog/avatar-3.webp'


const _hoisted_1 = { class: "shop-details-wrap pt-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xxl-10 offset-xxl-1" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "single-product-details" }
const _hoisted_8 = { class: "product-more-option" }
const _hoisted_9 = { class: "product-action-item" }
const _hoisted_10 = { class: "v-counter" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "product-more-option-item" }
const _hoisted_13 = { class: "product-more-option-item" }
const _hoisted_14 = { class: "taglist list-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("div", { class: "single-product-img bg-magnolia br-one round-10" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Image",
                  class: "d-block mx-auto"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"single-product-title\"><div class=\"product-price fs-26 fw-bold f-secondary text_secondary\"> $532.00 <span class=\"discount fw-medium fs-24\">$50.00</span></div><h1 class=\"section-title\">Kitten Cake</h1><div class=\"ratings d-flex align-items-center\"><ul class=\"list-style\"><li><img src=\"" + _imports_1 + "\" alt=\"Image\"></li><li><img src=\"" + _imports_1 + "\" alt=\"Image\"></li><li><img src=\"" + _imports_1 + "\" alt=\"Image\"></li><li><img src=\"" + _imports_1 + "\" alt=\"Image\"></li><li><img src=\"" + _imports_2 + "\" alt=\"Image\"></li></ul><span class=\"d-inline-block position-relative\"> (02) Reviews </span></div><p class=\"mb-0\"> Truffaut sriracha health goth slow-carb taiyaki. Kogi beard cred mukbang cornhole deep v, keffiyeh hoodie air plant messenger bag. Tofu 90’s ethical, pabst tumblr waistcoat brunch JOMO photo booth migas vape bicycle rights. </p></div>", 1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "minusBtn",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrement && _ctx.decrement(...args)))
                      }),
                      _createElementVNode("input", {
                        type: "text",
                        size: "25",
                        value: _ctx.quantity,
                        class: "count"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("button", {
                        class: "plusBtn",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.increment && _ctx.increment(...args)))
                      })
                    ]),
                    _createVNode(_component_router_link, {
                      to: "/wishlist",
                      class: "add-to-wishlist round-6"
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "ri-heart-line" }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "product-more-option-item" }, [
                    _createElementVNode("h5", { class: "fs-16 f-primary font-normal mb-0 text-para" }, " SKU : "),
                    _createElementVNode("span", { class: "fw-medium text_secondary" }, "254")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "fs-16 f-primary font-normal mb-0 text-para" }, " CATEGORY : ", -1)),
                    _createVNode(_component_router_link, {
                      to: "/shop-left-sidebar",
                      class: "fw-medium text_secondary"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Foods ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "fs-16 f-primary font-normal mb-0 text-para" }, " TAGS : ", -1)),
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Food")
                          ])),
                          _: 1
                        })
                      ]),
                      _cache[7] || (_cache[7] = _createTextVNode(" , ")),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode(" Popular ")
                          ])),
                          _: 1
                        })
                      ]),
                      _cache[8] || (_cache[8] = _createTextVNode(" , "))
                    ])
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "product-more-option-item" }, [
                    _createElementVNode("h5", { class: "fs-16 f-primary font-normal mb-0 text-para" }, " PRODUCT ID: "),
                    _createElementVNode("span", { class: "fw-medium text_secondary" }, "929H")
                  ], -1))
                ])
              ])
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row pb-100" }, [
            _createElementVNode("div", { class: "col-lg-12" }, [
              _createElementVNode("ul", {
                class: "nav nav-tabs single-product-tablist",
                role: "tablist"
              }, [
                _createElementVNode("li", { class: "nav-item" }, [
                  _createElementVNode("button", {
                    class: "nav-link active",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#tab_1",
                    type: "button",
                    role: "tab"
                  }, " Description ")
                ]),
                _createElementVNode("li", { class: "nav-item" }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#tab_3",
                    type: "button",
                    role: "tab"
                  }, " Reviews ")
                ])
              ]),
              _createElementVNode("div", { class: "tab-content product-tab-content" }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "tab_1",
                  role: "tabpanel"
                }, [
                  _createElementVNode("div", { class: "product_desc" }, [
                    _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col-xl-8 offset-xl-2" }, [
                        _createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt. Donec ut metus leo. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos. Sed is so luctus, dui eu sagittis sodales, nulla nibh sagittis augue, vel porttitor diam enim non metus. ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "tab_3",
                  role: "tabpanel"
                }, [
                  _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-xl-8 offset-xl-2" }, [
                      _createElementVNode("div", { class: "comment-box bg-magnolia br-one round-10 mb-45" }, [
                        _createElementVNode("h3", { class: "fs-34 mb-30" }, "02 Comments"),
                        _createElementVNode("div", { class: "comment-item-wrap" }, [
                          _createElementVNode("div", { class: "comment-item d-flex" }, [
                            _createElementVNode("div", { class: "comment-author round-circle" }, [
                              _createElementVNode("img", {
                                src: _imports_3,
                                alt: "Image",
                                class: "round-circle"
                              })
                            ]),
                            _createElementVNode("div", { class: "comment-info" }, [
                              _createElementVNode("div", { class: "row align-items-center" }, [
                                _createElementVNode("div", { class: "col-md-9" }, [
                                  _createElementVNode("h5", null, "Amenda Smith"),
                                  _createElementVNode("ul", { class: "d-flex align-items-center list-style" }, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_2,
                                        alt: "Image"
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", { class: "col-md-12" }, [
                                  _createElementVNode("p", null, " he design is simple and elegant. The customer support on this product is also amazing. I would highly recommend you to purchase templates from the Prag. ")
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", { class: "comment-item d-flex" }, [
                            _createElementVNode("div", { class: "comment-author round-circle" }, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                alt: "Image",
                                class: "round-circle"
                              })
                            ]),
                            _createElementVNode("div", { class: "comment-info" }, [
                              _createElementVNode("div", { class: "row align-items-center" }, [
                                _createElementVNode("div", { class: "col-md-9" }, [
                                  _createElementVNode("h5", { class: "fs-20" }, "Tony Stark"),
                                  _createElementVNode("ul", { class: "d-flex align-items-center list-style" }, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "Image"
                                      })
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("img", {
                                        src: _imports_2,
                                        alt: "Image"
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", { class: "col-md-12" }, [
                                  _createElementVNode("p", null, " he design is simple and elegant. The customer support on this product is also amazing. I would highly recommend you to purchase templates from the Prag. ")
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "client-review-form" }, [
                        _createElementVNode("div", { class: "comment-form-title" }, [
                          _createElementVNode("h4", { class: "text-black" }, "Add A Review"),
                          _createElementVNode("p", null, " Your email address will not be published. Required fields are marked * ")
                        ]),
                        _createElementVNode("div", { class: "comment-form-title" }, [
                          _createElementVNode("h4", null, "Your Ratings"),
                          _createElementVNode("ul", { class: "d-flex align-items-center list-style" }, [
                            _createElementVNode("li", null, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Image"
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Image"
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Image"
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Image"
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("img", {
                                src: _imports_2,
                                alt: "Image"
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("form", {
                          action: "#",
                          class: "comment-form mt-4"
                        }, [
                          _createElementVNode("div", { class: "row" }, [
                            _createElementVNode("div", { class: "col-md-6" }, [
                              _createElementVNode("div", { class: "form-group mb-15" }, [
                                _createElementVNode("input", {
                                  type: "text",
                                  name: "name",
                                  id: "name",
                                  class: "br-one round-6 bg-transparent w-100 h-50",
                                  required: "",
                                  placeholder: "Name*"
                                })
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-6" }, [
                              _createElementVNode("div", { class: "form-group mb-15" }, [
                                _createElementVNode("input", {
                                  type: "email",
                                  name: "email",
                                  id: "email",
                                  class: "br-one round-6 bg-transparent w-100 h-50",
                                  required: "",
                                  placeholder: "Email Address*"
                                })
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-lg-12" }, [
                              _createElementVNode("div", { class: "form-group mb-15" }, [
                                _createElementVNode("textarea", {
                                  name: "messages",
                                  id: "messages",
                                  cols: "30",
                                  rows: "6",
                                  class: "br-one round-10 bg-transparent w-100 h-180 resize-0",
                                  placeholder: "Please Enter Your Comment Here"
                                })
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-12" }, [
                              _createElementVNode("div", { class: "form-check checkbox" }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: "test_2"
                                }),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: "test_2"
                                }, " Save my name, email, and website in this browser for the next time I comment. ")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-12 mt-3" }, [
                              _createElementVNode("button", { class: "btn style-one d-block w-100" }, " Post A Review ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], -1))
        ])
      ])
    ])
  ]))
}